import * as Sentry from '@sentry/react';

// this bug happens when we just made release
// it looks like "Cannot read properties of undefined (reading 'length')" in file node_modules/@aws-amplify/auth/lib-esm/Auth.js:1512
export function isAmplifyUserAttrsLengthBug(event: Sentry.Event): boolean {
  const exception = event.exception?.values?.[0];
  if (
    !(
      exception?.type === 'TypeError' &&
      /Cannot read properties of undefined \(reading 'length'\)/.test(exception?.value || '')
    )
  ) {
    return false;
  }

  const frames = exception?.stacktrace?.frames || [];

  const hasAmplifyFrame = frames.some((f) =>
    /(node_modules|\.vite)\/deps\/aws-amplify\.js/.test(f.filename || ''),
  );

  const hasAmplifyAuthFns = frames.some((f) =>
    /AuthClass2\.<anonymous>|user\.getUserData/.test(f.function || ''),
  );

  const isUnhandledRejection = exception?.mechanism?.handled === false || event?.level === 'error';

  return hasAmplifyFrame && hasAmplifyAuthFns && isUnhandledRejection;
}
